export default {
  data() {
    return {
      props: {
        'fontList': {
          "Abuget": "abuget",
          "Adella": "adella",
          "Advantage": "advantage",
          "Amatic": "amatic",
          "Andale Mono": "andale mono, times",
          "Anton": "anton",
          "Arial Black": "arial black, avant garde",
          "Arial": "arial, helvetica, sans-serif",
          "Artega": "artega",
          "Assistant Bold": "assistant bold",
          "Assistant Light": "assistant light",
          "Assistant Semibold": "assistant semibold",
          "Assistant": "assistant",
          "Autobus": "autobus",
          "Barlow Extra Light": "barlow extra light",
          "Barlow Medium": "barlow medium",
          "Basic": "basic",
          "Bebas Neue": "bebas neue",
          "Best Week": "best week",
          "Book Antiqua": "book antiqua, palatino",
          "Breathe": "breathe",
          "Bree Serif": "bree serif",
          "Caudex": "caudex",
          "Caveat Bold": "caveat bold",
          "Caveat": "caveat",
          "Charrie": "charrie",
          "Chelsea Market": "chelsea market",
          "Cinzel Semibold": "cinzel semibold",
          "Cinzel": "cinzel",
          "Comic Sans MS": "comic sans ms, sans-serif",
          "Cookie": "cookie",
          "Coolvetica": "coolvetica",
          "Corben": "corben",
          "Cormorant Garamond Light": "cormorant garamond light",
          "Cormorant Garamond Semibold": "cormorant garamond semibold",
          "Courier New": "courier new",
          "Curve Bold": "curve bold",
          "Curve Regular": "curve regular",
          "Curve Slim": "curve slim",
          "Damion": "damion",
          "Dancing Script": "dancing script",
          "EB Garamond Extrabold": "eb garamond extrabold",
          "EB Garamond": "eb garamond",
          "Enriqueta Bold": "enriqueta bold",
          "Enriqueta Medium": "enriqueta medium",
          "Enriqueta Semibold": "enriqueta semibold",
          "Enriqueta": "enriqueta",
          "Exquite": "exquite",
          "Fahkwang Medium": "fahkwang medium",
          "Fahkwang": "fahkwang",
          "Feeling": "feeling",
          "Forum": "forum",
          "Frank Ruhl Libre Bold": "frank ruhl libre bold",
          "Frank Ruhl Libre": "frank ruhl libre",
          "Fraunces Bold": "fraunces bold",
          "Fraunces Light": "fraunces light",
          "Fraunces Thin": "fraunces thin",
          "Fredericka the Great": "fredericka the great",
          "Geist Bold": "geist bold",
          "Geist Light": "geist light",
          "Geist Thin": "geist thin",
          "Geist": "geist",
          "Georgia Estate": "georgia estate",
          "Georgia": "georgia, palatino",
          "Harshita": "harshita",
          "Heebo Black": "heebo black",
          "Heebo Bold": "heebo bold",
          "Heebo Extralight": "heebo extralight",
          "Heebo Semibold": "heebo semibold",
          "Heebo": "heebo",
          "Hell Deco": "hell deco",
          "Helsinki": "helsinki",
          "Helvetica": "helvetica",
          "Impact": "impact, chicago",
          "Jockey One": "jockey one",
          "Josefin Slab Bold": "josefin slab bold",
          "Josefin Slab": "josefin slab",
          "Jura Bold": "jura bold",
          "Jura": "jura",
          "Karantina Light": "karantina light",
          "Karantina": "karantina",
          "Kelly Slab": "kelly slab",
          "La Lemonti Italic": "la lemonti italic",
          "La Lemonti": "la lemonti",
          "Laisha": "laisha",
          "Lato Black": "Lato Black, sans-serif",
          "Lato Bold": "lato bold",
          "Lato Italic": "lato italic",
          "Lato Light": "Lato Light, sans-serif",
          "Lato Thin": "Lato Thin, sans-serif",
          "Lato": "Lato, sans-serif",
          "Lavener": "lavener",
          "Lexa": "lexa",
          "Lobster": "lobster",
          "Marck Script": "marck script",
          "Marmelad": "marmelad",
          "Monofonto": "monofonto",
          "Monoton": "monoton",
          "Montserrat Light": "Montserrat Light, sans-serif",
          "Montserrat Semi Bold": "Montserrat Semi Bold, sans-serif",
          "Montserrat": "Montserrat, sans-serif",
          "Mr De Haviland": "mr de haviland",
          "Muli Black": "Muli Black, sans-serif",
          "Muli Bold Italic": "muli bold italic",
          "Muli Bold": "muli bold",
          "Muli Italic": "muli italic",
          "Muli Light": "Muli Light, sans-serif",
          "Muli Semibold": "muli semibold",
          "Muli": "Muli, sans-serif",
          "Mutua": "mutua",
          "Niconne": "niconne",
          "Nobile Bold": "nobile bold",
          "Nobile": "nobile",
          "Noticia Text": "noticia text",
          "Nunito": "Nunito, sans-serif",
          "Open Sans Bold": "open sans bold",
          "Open Sans": "Open Sans, helvetica, sans-serif",
          "Oswald Bold": "oswald bold",
          "Oswald Extralight": "oswald extralight",
          "Oswald Medium": "oswald medium",
          "Oswald": "oswald",
          "Ottmar Hollington": "ottmar hollington",
          "Overlock Patrick Hand": "overlock patrick hand",
          "Play Bold": "play bold",
          "Play": "play",
          "Playfair Display Black Italic": "playfair display black italic",
          "Playfair Display Black": "playfair display black",
          "Playfair Display Bold Italic": "playfair display bold italic",
          "Playfair Display Bold": "playfair display bold",
          "Playfair Display": "Playfair Display, sans-serif",
          "Poppins Bold Italic": "poppins bold italic",
          "Poppins Bold": "poppins bold",
          "Poppins Extralight Italic": "poppins extralight italic",
          "Poppins Extralight": "poppins extralight",
          "Poppins Italic": "poppins italic",
          "Poppins Semibold Italic": "poppins semibold italic",
          "Poppins Semibold": "poppins semibold",
          "Poppins": "poppins",
          "Quicksand Bold": "quicksand bold",
          "Quicksand Medium": "quicksand medium",
          "Quicksand Semibold": "quicksand semibold",
          "Quicksand": "quicksand",
          "Raleway Bold Italic": "raleway bold italic",
          "Raleway Bold": "raleway bold",
          "Raleway Semibold Italic": "raleway semibold italic",
          "Raleway Semibold": "raleway semibold",
          "Roboto Black Italic": "roboto black italic",
          "Roboto Black": "roboto black",
          "Roboto Bold Italic": "roboto bold italic",
          "Roboto Bold": "roboto bold",
          "Roboto Italic": "roboto italic",
          "Roboto Light Italic": "roboto light italic",
          "Roboto Light": "roboto light",
          "Roboto": "Roboto, sans-serif",
          "Rozha One": "rozha one",
          "Rubik Bold": "rubik bold",
          "Rubik Light": "rubik light",
          "Rubik Medium": "rubik medium",
          "Rubik": "rubik",
          "Sacramento": "sacramento",
          "Sail": "sail",
          "Sarina": "sarina",
          "Seaside Resort": "seaside resort",
          "Space Grotesk Bold": "space grotesk bold",
          "Space Grotesk": "space grotesk",
          "Still Time": "still time",
          "Summer Pisces": "summer pisces",
          "Symbol": "symbol",
          "Syne Bold": "syne bold",
          "Syne": "syne",
          "Tahoma": "tahoma, arial, helvetica, sans-serif",
          "Terminal": "terminal, monaco",
          "Thirsty Caps": "thirsty caps",
          "Timeburner Bold": "timeburner bold",
          "Timeburner": "timeburner",
          "Times New Roman": "times new roman, times",
          "Trebuchet MS": "trebuchet ms, geneva",
          "Verdana": "verdana, geneva",
          "Want Coffee": "want coffee",
          "Webdings": "webdings",
          "Wingdings": "wingdings, zapf dingbats",
          "Work Sans Bold": "work sans bold",
          "Work Sans Light": "work sans light",
          "Work Sans Medium": "work sans medium",
          "Work Sans": "work sans",
          "Yukita Black": "yukita black",
          "Yukita Bold": "yukita bold",
          "Yukita Extrabold": "yukita extrabold",
          "Yukita Light": "yukita light",
          "Yukita Medium": "yukita medium",
          "Yukita Regular": "yukita regular",
          "Yukita Semibold": "yukita semibold"
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/base/FontList.js